import { createSlice } from "@reduxjs/toolkit";
import { createLedgers } from "../api/api";

const initialState = {
  loading: false,
  error: {},
  ledgerResponseData: [],
};

const createLedger = createSlice({
  name: 'createLedger',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      createLedgers.pending, // <- Correct action type
      (state) => {
        state.loading = true;
        state.error = {};
        state.ledgerResponseData = [];
      }
    );
    builder.addCase(
      createLedgers.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.ledgerResponseData = [];
      }
    );
    builder.addCase(
      createLedgers.fulfilled,
      (state, action) => {
        state.loading = false;
        state.error = {};
        state.ledgerResponseData = action.payload;
      }
    );
  },
});

export default createLedger.reducer;
